import { computed, observable, makeObservable } from 'mobx';
import _ from 'lodash';
import {QAQuestion} from '../questions';

class SurveyQuestion extends QAQuestion {
  name;

  constructor(other) {
    super();

    this.required = true;

    makeObservable(this, {
      name: observable,
      commaSeparatedOptions: computed
    });

    this.merge(other);
  }

  get commaSeparatedOptions() {
    return _.chain(this.options)
      .map('value')
      .join(', ')
      .value();
  }
}

export default SurveyQuestion;
